import { useEffect } from 'react';
import {
  array, bool, object, string, number, func,
} from 'prop-types';
import { useInView } from 'react-intersection-observer';

import ProductsGrid from 'components/productsGrid';
import {
  DEFAULT_LIMIT, updateQuerystringParam,
} from 'utils/helpers';

function PaginatedGrid({
  products, target, product, locale,
  colXS, colMD, colLG, colXL, colXXL,
  page, handleLoadNextPage, withLabel,
  currentList, camperlab, withHover, recalculating, voucherApplied,
  loadingNextPage, currentListName,
}) {
  const { ref: refTop, inView: inViewTop } = useInView({
    threshold: 0,
    rootMargin: '40% 0%',
  });
  const { ref: refLoadMore, inView: inViewLoadMore } = useInView({
    threshold: 1,
    rootMargin: '0% 0%',
    triggerOnce: true,
  });

  useEffect(() => {
    if (!loadingNextPage && inViewTop) {
      const qs = window.location.search;
      handleLoadNextPage(page - 1);
      updateQuerystringParam(qs, 'page', page, 1);
    }
  }, [ inViewTop ]);

  useEffect(() => {
    if (!loadingNextPage && inViewLoadMore) {
      handleLoadNextPage(page + 1);
    }
  }, [ inViewLoadMore ]);

  return (
    <>
      <div ref={refTop}></div>
      <ProductsGrid
        origin='grid'
        currentList={currentList}
        products={products}
        target={target}
        product={product}
        locale={locale}
        colXS={colXS}
        colMD={colMD}
        colLG={colLG}
        colXL={colXL}
        colXXL={colXXL}
        camperlab={camperlab}
        withHover={withHover}
        recalculating={recalculating}
        voucherApplied={voucherApplied}
        withModal={true}
        withLabel={withLabel}
        currentListName={currentListName}
        page={page}
      />
      <div ref={refLoadMore}></div>
    </>
  );
}

PaginatedGrid.propTypes = {
  products: array,
  loading: bool,
  colXS: object,
  colMD: object,
  colLG: object,
  colXL: object,
  colXXL: object,
  target: string,
  product: string,
  locale: string,
  withPlaceholder: bool,
  withHover: bool,
  withLabel: bool,
  infiniteScrollLoading: bool,
  defaultLimit: number,
  page: number,
  handleLoadNextPage: func.isRequired,
  currentList: string,
  camperlab: bool,
  recalculating: bool,
  voucherApplied: bool,
  loadingNextPage: bool,
  hasModal: bool,
  currentListName: string,
};

PaginatedGrid.defaultProps = {
  products: [],
  loading: false,
  colXS: { span: 12 },
  colMD: { span: 8 },
  colLG: { span: 8 },
  colXL: { span: 8 },
  colXXL: { span: 6 },
  withPlaceholder: false,
  withHover: true,
  withLabel: false,
  infiniteScrollLoading: false,
  defaultLimit: DEFAULT_LIMIT,
  page: 1,
  camperlab: false,
  recalculating: false,
  voucherApplied: false,
  loadingNextPage: false,
  hasModal: true,
};

export default PaginatedGrid;
